import { persistentAtom } from './persistence';
import { $serverState } from './server';
import type { ServerInfo } from '@/utils/connectionKeyUtils';
import { computed } from 'nanostores';

/**
 * Remote server a client is connected to.
 * This is distinct from `$serverState` (local Tauri-hosted server info).
 */
export const $connectedServer = persistentAtom<ServerInfo | null>(
  'connected-server',
  null,
);

export function setConnectedServer(server: ServerInfo | null) {
  $connectedServer.set(server);
}

export type ConnectionRole = 'disconnected' | 'hosting' | 'connected';

export const $connectionRole = computed(
  [$serverState, $connectedServer],
  (serverState, connectedServer): ConnectionRole => {
    if (serverState) {
      return 'hosting';
    }

    if (connectedServer) {
      return 'connected';
    }

    return 'disconnected';
  },
);

export const $effectiveRemoteServer = computed(
  [$serverState, $connectedServer],
  (serverState, connectedServer): ServerInfo | null => {
    if (serverState) {
      return null;
    }

    return connectedServer;
  },
);
